import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownloadOutlined, FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons';
import { exportToCSV, exportToPDF } from '@/utils/export';

interface ExportColumn {
  header: string;
  key: string;
  width?: number;
}

interface ExportButtonsProps {
  title: string;
  columns: ExportColumn[];
  data: any[];
  filename: string;
}

const ExportButtons: React.FC<ExportButtonsProps> = ({ title, columns, data, filename }) => {
  const handleExportCSV = () => {
    exportToCSV({ title, columns, data, filename });
  };

  const handleExportPDF = () => {
    exportToPDF({ title, columns, data, filename });
  };

  const items = [
    {
      key: 'csv',
      label: 'Exportar CSV',
      icon: <FileExcelOutlined />,
      onClick: handleExportCSV,
    },
    {
      key: 'pdf',
      label: 'Exportar PDF',
      icon: <FilePdfOutlined />,
      onClick: handleExportPDF,
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Button icon={<DownloadOutlined />}>
        Exportar
      </Button>
    </Dropdown>
  );
};

export default ExportButtons;
